import React, { FC, ReactNode } from "react";

interface GradientButtonProps {
    children: ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    className?: string; // for additional custom styling
}

const GradientStrokeButton: FC<GradientButtonProps> = ({ children, onClick, className, disabled = false }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`relative inline-flex items-center justify-center p-[1px] rounded-lg font-semibold bg-gradient-to-r from-primary to-secondary overflow-hidden group ${className}`}
        >
            {/* Inner white container */}
            <div className="bg-white rounded-lg w-full px-4 py-2 text-center">
                {/* Gradient text */}
                <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                    {children}
                </span>
            </div>
        </button>
    );
};

export default GradientStrokeButton;
